import type { BomFlowNode, BomFlowEdge } from '../../contexts/types';

/**
 * BOM作成モーダルの「サンプル」タブで表示する不変のお手本データ。
 * 実際のBOM実例（BoiseBuffalo案件）を元に、Process Codeの有無で工程ノード/材料を仕分けて変換したもの。
 * 変換元・変換ルール・座標算出方法は 設計書/ver3.0/8月/No410_BOM入力操作検討/詳細設計/09_サンプルデータ変換設計.md を参照。
 * position は handleLayoutClick（BomCreateModal.tsx）と同一の整列アルゴリズムで機械的に算出した値。
 */
export const bomSampleNodes: BomFlowNode[] = [
  {
    id: 'sample-1',
    type: 'bomProcess',
    position: { x: 2270, y: 30 },
    data: { modelNo: '', processCode: 'Packing', itemNo: '-', itemName: 'Packing', materials: [] },
  },
  {
    id: 'sample-2',
    type: 'bomProcess',
    position: { x: 1990, y: 30 },
    data: { modelNo: 'MDL-SMP01', processCode: 'OQC12', itemNo: 'PT-10002', itemName: 'ASAS68-W9A', materials: [] },
  },
  {
    id: 'sample-3',
    type: 'bomProcess',
    position: { x: 1710, y: 30 },
    data: {
      modelNo: '', processCode: 'F/A12', itemNo: 'PT-10003', itemName: 'FINAL-ASSY',
      materials: [{ id: 'mat-sample-19', itemNo: 'PT-10019', itemName: 'SHIELD CAN' }],
    },
  },
  {
    id: 'sample-4',
    type: 'bomProcess',
    position: { x: 1430, y: 30 },
    data: {
      modelNo: '', processCode: 'P/R01', itemNo: 'PT-10004', itemName: 'CARRIER-RIGID-FLEX-ASSY',
      materials: [{ id: 'mat-sample-18', itemNo: 'PT-10018', itemName: 'HANSON RIGID FLEX' }],
    },
  },
  {
    id: 'sample-5',
    type: 'bomProcess',
    position: { x: 1150, y: 30 },
    data: {
      modelNo: '', processCode: 'P/R12-1', itemNo: 'PT-10005', itemName: 'CARRIER-MAGNET-ASSY',
      materials: [{ id: 'mat-sample-17', itemNo: 'PT-10017', itemName: 'DRIVE MAGNET NHREE 100RC' }],
    },
  },
  {
    id: 'sample-6',
    type: 'bomProcess',
    position: { x: 870, y: 30 },
    data: {
      modelNo: '', processCode: 'P/R12-2', itemNo: 'PT-10006', itemName: 'CARRIER-B-SPRING-ASSY',
      materials: [{ id: 'mat-sample-16', itemNo: 'PT-10016', itemName: 'BTM-SPRING' }],
    },
  },
  {
    id: 'sample-7',
    type: 'bomProcess',
    position: { x: 590, y: 30 },
    data: {
      modelNo: '', processCode: 'P/R12-3', itemNo: 'PT-10007', itemName: 'CARRIER-AF-FLEXURE-ASSY',
      materials: [{ id: 'mat-sample-15', itemNo: 'PT-10015', itemName: 'BESSO AF FLEXURE' }],
    },
  },
  {
    id: 'sample-8',
    type: 'bomProcess',
    position: { x: 310, y: 30 },
    data: { modelNo: '', processCode: 'P/R12-4', itemNo: 'PT-10008', itemName: 'CARRIER-APS-MAGNET-ASSY', materials: [] },
  },
  {
    id: 'sample-9',
    type: 'bomProcess',
    position: { x: 30, y: 30 },
    data: {
      modelNo: '', processCode: 'SUB03', itemNo: 'PT-10009', itemName: 'CARRIER-UNIT-PROCESSED-A',
      materials: [
        { id: 'mat-sample-10', itemNo: 'PT-10010', itemName: 'CARRIER-UNIT' },
        { id: 'mat-sample-11', itemNo: 'PT-10011', itemName: 'APS MAGNET NHREE 100RC' },
      ],
    },
  },
  {
    id: 'sample-12',
    type: 'bomProcess',
    position: { x: 310, y: 160 },
    data: {
      modelNo: '', processCode: 'P/R12-5', itemNo: 'PT-10012', itemName: 'MAGNET-HOLDER-ASSY',
      materials: [
        { id: 'mat-sample-13', itemNo: 'PT-10013', itemName: 'MAGNET HOLDER' },
        { id: 'mat-sample-14', itemNo: 'PT-10014', itemName: 'AF DAMPING PIN' },
      ],
    },
  },
  {
    id: 'sample-20',
    type: 'bomProcess',
    position: { x: 1990, y: 160 },
    data: { modelNo: 'MDL-SMP02', processCode: 'OQC11', itemNo: 'PT-10020', itemName: 'ASAS69-W9S', materials: [] },
  },
  {
    id: 'sample-21',
    type: 'bomProcess',
    position: { x: 1710, y: 160 },
    data: { modelNo: '', processCode: 'F/A11', itemNo: 'PT-10021', itemName: 'FINAL-ASSY', materials: [] },
  },
  {
    id: 'sample-22',
    type: 'bomProcess',
    position: { x: 1430, y: 160 },
    data: {
      modelNo: '', processCode: 'P/R02-1', itemNo: 'PT-10022', itemName: 'SP-ASSY',
      materials: [{ id: 'mat-sample-31', itemNo: 'PT-10031', itemName: 'FENDER' }],
    },
  },
  {
    id: 'sample-23',
    type: 'bomProcess',
    position: { x: 1150, y: 160 },
    data: {
      modelNo: '', processCode: 'P/R02-2', itemNo: 'PT-10023', itemName: 'BASE-ASSY',
      materials: [{ id: 'mat-sample-30', itemNo: 'PT-10030', itemName: 'INSERT BASE' }],
    },
  },
  {
    id: 'sample-24',
    type: 'bomProcess',
    position: { x: 870, y: 160 },
    data: { modelNo: '', processCode: 'SUB01-1', itemNo: 'PT-10024', itemName: 'FLEXURE-UF-ASSY', materials: [] },
  },
  {
    id: 'sample-25',
    type: 'bomProcess',
    position: { x: 590, y: 160 },
    data: {
      modelNo: '', processCode: 'SUB01-2', itemNo: 'PT-10025', itemName: 'FLEXURE-SMT-ASSY',
      materials: [{ id: 'mat-sample-29', itemNo: 'PT-10029', itemName: 'FLEXURE' }],
    },
  },
  {
    id: 'sample-26',
    type: 'bomProcess',
    position: { x: 310, y: 290 },
    data: {
      modelNo: '', processCode: 'SUB01-3', itemNo: 'PT-10026', itemName: 'DAMPING-PIN-ASSY',
      materials: [
        { id: 'mat-sample-27', itemNo: 'PT-10027', itemName: 'SP DAMPING PIN' },
        { id: 'mat-sample-28', itemNo: 'PT-10028', itemName: 'STETSON SUBSTRATE ASSY' },
      ],
    },
  },
];

export const bomSampleEdges: BomFlowEdge[] = [
  { id: 'e-sample-2', source: 'sample-2', target: 'sample-1' },
  { id: 'e-sample-3', source: 'sample-3', target: 'sample-2' },
  { id: 'e-sample-4', source: 'sample-4', target: 'sample-3' },
  { id: 'e-sample-5', source: 'sample-5', target: 'sample-4' },
  { id: 'e-sample-6', source: 'sample-6', target: 'sample-5' },
  { id: 'e-sample-7', source: 'sample-7', target: 'sample-6' },
  { id: 'e-sample-8', source: 'sample-8', target: 'sample-7' },
  { id: 'e-sample-9', source: 'sample-9', target: 'sample-8' },
  { id: 'e-sample-12', source: 'sample-12', target: 'sample-7' },
  { id: 'e-sample-20', source: 'sample-20', target: 'sample-1' },
  { id: 'e-sample-21', source: 'sample-21', target: 'sample-20' },
  { id: 'e-sample-22', source: 'sample-22', target: 'sample-21' },
  { id: 'e-sample-23', source: 'sample-23', target: 'sample-22' },
  { id: 'e-sample-24', source: 'sample-24', target: 'sample-23' },
  { id: 'e-sample-25', source: 'sample-25', target: 'sample-24' },
  { id: 'e-sample-26', source: 'sample-26', target: 'sample-25' },
];
